import { Spin } from 'antd';

export function PageLoading() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 320,
        width: '100%',
      }}
    >
      <Spin size="large" />
    </div>
  );
}
